<form #createlesson="ngForm" name="createlesson" id="createlesson" (ngSubmit)="addlesson()" class="course-form mb-0">

  <header class="cf-head">
    <span class="cf-head__icon"><i class="fas fa-book-open" aria-hidden="true"></i></span>
    <div class="cf-head__text">
      <h1 class="cf-head__title">{{classid ? 'Edit Lesson' : 'Create New Lesson'}}</h1>
      <p class="cf-head__sub">Add lesson details and content settings</p>
    </div>
    <div class="cf-head__actions">
      <button class="btn btn--warning m-0" type="button" (click)="canceledit()">Cancel</button>
      <button [disabled]="createlesson.invalid && !this.classid" class="btn m-0" type="submit">
        <i class="fas fa-save" aria-hidden="true"></i> Save
      </button>
    </div>
  </header>

  <section class="cf-card">
    <h2 class="cf-card__title"><i class="far fa-file-alt" aria-hidden="true"></i> Lesson Details</h2>

    <div class="fieldset fieldset--lg">
      <label class="legend" for="title">Lesson Title <span class="requiredfield">*</span></label>
      <input type="text" class="text-field" required [(ngModel)]="lesson.title" #title name="title" id="title" autofocus>
      <button type="button" data-toggle="dropdown" aria-expanded="false" title="Lesson title"
        class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
          class="fa fa-info-circle"></i></button>
      <div class="info-popup dropdown-menu p-2">
        <p class="form-info-p">The name students see in the course curriculum and on their progress timeline.</p>
      </div>
    </div>

    <div class="cf-grid">
      <div class="fieldset fieldset--lg">
        <label class="legend" for="publishdate">Publish Date</label>
        <input [owlDateTime]="rawpublisheddatetime" class="text-field" id="publishdate" name="publishdate" #publishdate
          [(ngModel)]="lesson.publishdate">
        <button type="button" [owlDateTimeTrigger]="rawpublisheddatetime"
          class="owlDateTimeTrigger position-absolute right-4 top-0 bottom-0 m-auto d-flex align-items-center px-3 bg-transparent border-0 text-body"
          title="Calendar">
          <i class="fa fa-calendar"></i>
        </button>
        <owl-date-time #rawpublisheddatetime></owl-date-time>
        <button type="button" data-toggle="dropdown" aria-expanded="false" title="Date of availability"
          class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
            class="fa fa-info-circle"></i></button>
        <div class="info-popup dropdown-menu p-2">
          <p class="form-info-p">This is the date from which the lesson will be made available to enrolled participants</p>
        </div>
      </div>

      <div class="fieldset fieldset--lg">
        <label for="timeestimate" class="legend">Estimated Completion Duration</label>
        <div>
          <input type="number" name="timeestimate" class="text-field w-50" [(ngModel)]="lesson.timenumber">
          <select class="text-field w-50" #selectTimeUnit>
            <option>Minute(s)</option>
            <option>Hour(s)</option>
          </select>
        </div>
        <button type="button" data-toggle="dropdown" aria-expanded="false" title="Estimated completion duration"
          class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
            class="fa fa-info-circle"></i></button>
        <div class="info-popup dropdown-menu p-2">
          <p class="form-info-p">Roughly how long the lesson takes. It shows on the lesson and counts towards the course's total length. Leave it empty and no time is shown.</p>
        </div>
      </div>

      <div class="fieldset fieldset--lg" [hidden]="!activateLessonDeadlineNotification">
        <label class="legend z-1" for="fixedMilestoneDate">Use Publish Date for Lesson Deadline</label>
        <select class="text-field" [(ngModel)]="lesson.usefixeddeadline"
          #fixedMilestoneDate name="fixedMilestoneDate" id="fixedMilestoneDate">
          <option [ngValue]="true">
            Yes
          </option>
          <option [ngValue]="false" selected>
            No
          </option>
        </select>
        <button type="button" data-toggle="dropdown" aria-expanded="false" title="Use publish date for lesson deadline"
          class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
            class="fa fa-info-circle"></i></button>
        <div class="info-popup dropdown-menu p-2">
          <p class="form-info-p">Yes counts the deadline from the lesson's publish date, so every student works to the same due date. No counts it from the day each student enrolled.</p>
        </div>
      </div>

      <div class="fieldset fieldset--lg" [hidden]="!activateLessonDeadlineNotification">
        <label for="milestoneestimate" class="legend">Lesson Deadline From {{lesson.usefixeddeadline ? 'Publish Date' : 'Start of Lesson'}}</label>
        <div>
          <input type="number" name="milestoneestimate" class="text-field w-50" [(ngModel)]="lesson.milestonetimenumber">
          <select class="text-field w-50" #selectMilestoneTimeUnit>
            <option>Hour(s)</option>
            <option>Day(s)</option>
          </select>
        </div>
        <button type="button" data-toggle="dropdown" aria-expanded="false" title="Lesson deadline"
          class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
            class="fa fa-info-circle"></i></button>
        <div class="info-popup dropdown-menu p-2">
          <p class="form-info-p">How long a student has to finish the lesson, counted from whichever start date you chose above. They are emailed a reminder 24 hours before it. Leave it at 0 for no deadline.</p>
        </div>
      </div>
    </div>
  </section>

  <section class="cf-card">
    <div class="cf-description">
      <div class="fieldset fieldset--note">
        <label class="legend z-1">Lesson Summary <span class="requiredfield">*</span></label>
        <quill-editor required [(ngModel)]="lesson.description" #description name="description"
          placeholder="Enter Short Description of Lesson"></quill-editor>
      </div>
      <aside class="cf-tips">
        <h3><i class="far fa-lightbulb" aria-hidden="true"></i> Tips for a clear summary</h3>
        <ul>
          <li>Say what the lesson covers</li>
          <li>Note anything students need before starting</li>
          <li>Keep it short — the full content goes in the lesson note</li>
        </ul>
      </aside>
    </div>
  </section>

  <div class="cf-footer">
    <span class="cf-footer__hint">
      <i class="fas fa-book-open" aria-hidden="true"></i>
      <span>{{classid ? 'Update this lesson\'s details.' : 'After saving, you can add notes, files and assessments.'}}</span>
    </span>
    <span class="cf-footer__actions">
      <button class="btn btn--warning m-0" type="button" (click)="canceledit()">Cancel</button>
      <button [disabled]="createlesson.invalid && !this.classid" class="btn m-0" type="submit">Save</button>
    </span>
  </div>
</form>